import { render, staticRenderFns } from "./SignupPanel.vue?vue&type=template&id=1aba6248"
import script from "./SignupPanel.vue?vue&type=script&lang=js"
export * from "./SignupPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports